"use client";

import AdsBanner from "@/app/components/AdsBanner";
import MyCard from "@/app/components/MyCard";
import { ViewMoreNews } from "@/app/components/news/ViewMoreNews";
import { isPublishedBlog } from "@/helpers";
import useAxiosQuery from "@/hooks/useMyQuery";
import { axiosClient } from "@/lib/axiosClient";
import type { BlogData, INewsResponse } from "@/models/news";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Typography } from "antd/lib";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import { useRouter } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { useLanguageContext } from "@/context/LanguageContext";
import ExploreProducts from "@/app/components/news/ExploreProducts";

const NewsMainContent = dynamic(() => import("@/app/components/news/MainContent"), { ssr: false });
const DetailsSidebar = dynamic(() => import("@/app/components/news/DetailsSidebar"), { ssr: false });
const BlogNews = dynamic(() => import("@/app/components/news/BlogNews"), { ssr: false });

const NewsDetailMainContent = ({ slug }: { slug: string }) => {
  const router = useRouter();
  const { language } = useLanguageContext();

  const t = useTranslations("news");
  const [post, setPost] = useState<INewsResponse>();

  const { data: blogRes, isLoading } = useAxiosQuery<{
    data: { total: number; posts: BlogData[] };
  }>({
    url: "/v1/blog",
    method: "get",
  });

  const blogList = useMemo(() => blogRes?.data.posts.filter(item => isPublishedBlog(item)), [blogRes?.data.posts]);

  useEffect(() => {
    (async () => {
      const post: { data: { data: INewsResponse } } = await axiosClient.get(`/v1/market-insight/id/${slug}`);
      setPost(post.data.data);
    })();
  }, [slug]);

  return (
    <>
      <AdsBanner rightComponent={<ExploreProducts />} />
      <div className="flex flex-col gap-4 items-start pt-4 max-w-[1152px] mx-auto">
        <Button
          icon={<ArrowLeftOutlined className="text-base" />}
          type="text"
          className="mb-6 px-0 text-lg leading-6 hover:bg-transparent"
          onClick={() => router.push(`/${language}/news`)}
        >
          {t("Back_to_previous_page")}
        </Button>
        <div className="grid gap-5 max-w-full lg:grid-cols-[minmax(0,776px)_352px]">
          <div className="grid-area-content mb-5 w-full">
            <NewsMainContent data={post as BlogData & INewsResponse} />
          </div>
          <DetailsSidebar blogList={blogList} />
        </div>
        {/* same topic */}
        <MyCard title={t("Same_Topic")} className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
            {blogList?.slice(0, 6)?.map(news => (
              <BlogNews key={news.id} news={news} isHideDesc isLoading={isLoading} />
            ))}
            <ViewMoreNews />
          </div>
        </MyCard>
      </div>

      {/* Become a Klarda Analyst */}
      <div className="flex flex-col gap-2 text-center py-10 mt-10 rounded-lg px-2">
        <Typography.Title level={2}>{t("Become_content_writer")}</Typography.Title>
        <p className="block mb-3">{t("Millions_of_tech_blogs")}</p>
        <Button type="primary" className="w-fit mx-auto" href={`/${language}/registration-portal`}>
          {t("Submit_now")}
        </Button>
      </div>
    </>
  );
};

export default NewsDetailMainContent;



